import React from 'react';
import { convertEpochToDateDMY } from "../../../utils";
import { Row } from "react-bootstrap";

const FormatSlip = ({ scrutinyTable, scrutinyDetails, wordslist ,scrutinyData, id, logoData }) => {

    const date = convertEpochToDateDMY(scrutinyTable?.auditDetails.createdTime);
    const isDA = scrutinyData?.department === 'DA'
    const colorCodeUrl = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg"
    const colorCodeiner = isDA ? "#f06107ed" : "#000"
    const colorCode = "#1f4a7c"
    const nameOfDepartment = isDA ? "Development Authority" : "Awas Evam Vikas Parishad"

    console.log("abcdefgh", colorCode, nameOfDepartment,scrutinyData,scrutinyDetails ,isDA);
    return (
        <React.Fragment>
            {scrutinyTable && (
                <div className='FormatSlipbody'>
                    <div className="container bootstrap snippets bootdeys" >
                        <div style={{ display: "flex", padding: "5px", marginLeft: "15px" }}>
                            <img width="85" src={colorCodeUrl} alt="Himachal" />
                            <div><p style={{ marginLeft: "12px", fontSize: "23px", marginTop: "6px" }}>Govermment of Uttar Pradesh</p><p style={{ marginLeft: "12px", marginTop: "4px" }}>{nameOfDepartment}</p></div></div>
                        <div>
                            <strong> <hr /> </strong>
                            <br />
                            {/* <div style={{ marginBottom: "20px" }}>
                                <p>PAYMENT RECEIPT</p>
                            </div> */}
                            <div className="row" style={{ border: `10px solid ${colorCode}`, padding: "12px", position: "relative" }}>
                                {/* <div style={{ width: 40, height: 44, border: "10px solid green", position: "absolute", left: "-25px", top: "-26px", background: "#fff", zIndex: 1 }} />
                                <div style={{ width: 40, height: 44, border: "10px solid green", position: "absolute", right: "-25px", top: "-26px", background: "#fff", zIndex: 1 }} />
                                <div style={{ width: 40, height: 44, border: "10px solid green", position: "absolute", left: "-25px", bottom: "-26px", background: "#fff", zIndex: 1 }} />
                                <div style={{ width: 40, height: 44, border: "10px solid green", position: "absolute", right: "-25px", bottom: "-26px", background: "#fff", zIndex: 1 }} /> */}
                                <div className="col-sm-12" style={{ border: `5px solid ${colorCodeiner}`, padding: "25px" }}>
                                    <div style={{
                                        opacity: 0.09,
                                        position: "absolute",
                                        inset: 0,
                                        display: "flex",
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        flexDirection: "column",
                                        gap: 10,
                                        userSelect: "none"
                                    }} >
                                        <img width={200} src={colorCodeUrl} alt='hp' />
                                        <p>{nameOfDepartment}</p>
                                        <p>Govermment of Uttar Pradesh</p>
                                    </div>
                                    <div className="panel panel-default invoice" id="invoice">
                                        <div className="panel-body">
                                            <div className="invoice-ribbon"><div className="ribbon-inner" style={{ background: colorCode }}>PAID</div></div>

                                            <Row style={{ display: "block" }}>
                                                <div >
                                                    <img width="90" style={{ margin: "auto" }} src={logoData} alt="UttarPradesh" />
                                                </div>
                                            </Row>
                                            <Row style={{ textAlign: "center", fontSize: "33px", display: "block" }}>
                                                <div >
                                                    {id}
                                                </div>
                                            </Row>
                                            <Row style={{ display: "block" }}>
                                                <div style={{ textAlign: "center", fontSize: "22px", margin: "5px" }}>
                                                    <div style={{ width: "18rem", border: `2px solid ${colorCode}`, color: colorCode, margin: "auto", borderRadius: "50px" }}>
                                                        PAYMENT RECEIPT
                                                    </div>
                                                </div>
                                            </Row>
                                            <div style={{ display: "flex", justifyContent: "space-between", padding: "10px" }}>
                                                <div>No : {scrutinyTable.txnId}</div>
                                                <div>Dated : {date}</div>
                                            </div>
                                            <div style={{ fontFamily: "Arial, sans-serif", margin: "20px", backgroundColor: "#f5f5f5", }}>
                                                <div classname="receiptApp">

                                                    <h2 style={{ color: colorCode, textAlign: "center", margin: "5px" }}>Government of Uttar Pradesh</h2>

                                                    <div style={{ display: "block", marginBottom: "20px", marginLeft: "25px", color: "#333", textAlign: "left" }}>
                                                        <span style={{ display: "block", marginBottom: "5px" }}><strong>Name Of Professional  : Sh./Smt.</strong> {scrutinyDetails?.name} <br /></span>
                                                        <span style={{ display: "block", marginBottom: "5px" }}><strong>Phone No :</strong> {scrutinyDetails?.mobileNumber} <br /></span>
                                                        <span style={{ display: "block", marginBottom: "5px" }}><strong>Email Id :</strong> {scrutinyDetails?.emailId} <br /></span>
                                                        <span style={{ display: "block", marginBottom: "5px" }}><strong>Payment Received Bank :</strong> {scrutinyTable.gateway} <br /></span>
                                                        <span style={{ display: "block", marginBottom: "5px" }}><strong>Payment Status :</strong> {scrutinyTable.txnStatusMsg} <br /></span>
                                                        <span style={{ display: "block", marginBottom: "5px" }}><strong>Address:</strong> {scrutinyDetails?.correspondenceAddress?.address}</span>
                                                    </div>

                                                    <table className='dataTablePayment'>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ backgroundColor: colorCode, color: "#fff" }}>Description</th>
                                                                <th style={{ backgroundColor: colorCode, color: "#fff" }}>Amount of words</th>
                                                                <th style={{ backgroundColor: colorCode, color: "#fff" }}>Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>Applicaion Fee</td>
                                                                <td>{wordslist}</td>
                                                                <td> ₹ {scrutinyTable?.txnAmount}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <div style={{ marginTop: "20px", textAlign: "right", color: "#333" }}>
                                                        <strong>Total Amount:</strong> ₹ {scrutinyTable?.txnAmount}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* <Row>
                                                <div style={{ margin: "8px", padding: "3px", fontSize: "15px" }}>
                                                    <p>Received with thanks from Sh./Smt.  <span style={{ textDecoration: "underline", whiteSpace: "pre" }}><b>{scrutinyTable.user.name}                                                     </b></span></p>
                                                    <br></br>
                                                    <p>r/o <span style={{ textDecoration: "underline", whiteSpace: "pre" }}><b>Town/Village : {scrutinyDetails?.locality.village}, Tehsil: {scrutinyDetails?.locality.name}, Dist :{scrutinyDetails?.city}, State : Uttar Pradesh   </b></span></p>
                                                    <br></br>
                                                    <p> <span style={{ textDecoration: "underline", whiteSpace: "pre" }}><b>{scrutinyDetails?.city} ,{"Uttar Pradesh"}                                                    </b></span></p>
                                                    <br></br>
                                                    <p>Sum of Rupees <span style={{ textDecoration: "underline", whiteSpace: "pre" }}><b>{wordslist}                                            </b></span></p>
                                                    <br></br>
                                                    <p>{"A/C of Payment P.P. Case/Compounding/Change of landuse/Application/Cleanliness/other's"} </p>
                                                    <br></br><br></br>
                                                </div>
                                            </Row>
                                            <Row>

                                                <div className="lead marginbottom" style={{ border: "2px solid", fontSize: "20px", margin: "2px", padding: "0 10px" }}> ₹ {scrutinyTable.txnAmount}</div>

                                            </Row> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
}
export default FormatSlip;

